module.exports = __webpack_public_path__ + "img/best_buy.aabc18f4.jpg";